module.exports = __webpack_public_path__ + "static/img/jbeysh.61958f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/jbeysh.png
// module id = 1226
// module chunks = 0